import React from 'react';

const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.004" height="24.002" viewBox="0 0 24.004 24.002"><rect width="24" height="24" transform="translate(0.004)" fill="#fff" opacity="0"/><path d="M-18869.033,18927a1.027,1.027,0,0,1-.73-.3l-7.111-7.111a9.352,9.352,0,0,1-5.812,2.035,9.255,9.255,0,0,1-6.586-2.729,9.245,9.245,0,0,1-2.73-6.584,9.245,9.245,0,0,1,2.73-6.584,9.263,9.263,0,0,1,6.584-2.725,9.263,9.263,0,0,1,6.584,2.725,9.3,9.3,0,0,1,.693,12.4l7.111,7.111a1.037,1.037,0,0,1,0,1.463A1.035,1.035,0,0,1-18869.033,18927Zm-13.646-21.5a6.827,6.827,0,0,0-6.82,6.82,6.827,6.827,0,0,0,6.82,6.82,6.827,6.827,0,0,0,6.82-6.82A6.827,6.827,0,0,0-18882.68,18905.5Z" transform="translate(18892.004 -18903)" fill="#0f4975"/></svg>
  );
};

export default SearchIcon;
